const ServicesOverview = () => import('@/pages/technical-management/ServicesOverview.vue');
const HostingOverview = () => import('@/pages/technical-management/HostingOverview.vue');
const DomainOverview = () => import('@/pages/technical-management/DomainOverview.vue');
const DnsOverview = () => import('@/pages/technical-management/DnsOverview.vue');

export default [
    {
        path: '/services',
        name: 'services',
        component: ServicesOverview,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/services/:domain',
        name: 'domainOverview',
        component: DomainOverview,
        props: route => ({
            domain: route.params.domain
        }),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/services/:domain/dns',
        name: 'dnsOverview',
        component: DnsOverview,
        props: route => ({
            domain: route.params.domain
        }),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/services/:domain/hosting',
        name: 'hostingOverview',
        component: HostingOverview,
        props: route => ({
            domain: route.params.domain
        }),
        meta: {
            requiresAuth: true
        }
    }
];
